import type { AppState } from '@/types'
import { byId } from '@/utils/dom'

export type HomeSubmitCallback = (roomName: string, roomId: string) => void
export type NavigateCallback = (page: AppState['currentPage']) => void

export class HomePage {
  private el: HTMLElement
  private onSubmit: HomeSubmitCallback
  private onNavigate: NavigateCallback

  constructor(onSubmit: HomeSubmitCallback, onNavigate: NavigateCallback) {
    this.onSubmit = onSubmit
    this.onNavigate = onNavigate
    this.el = byId('page-home')
    this.bindEvents()
  }

  prefill(roomName: string, roomId: string): void {
    const nameInput = this.el.querySelector<HTMLInputElement>('#input-room-name')
    const idInput = this.el.querySelector<HTMLInputElement>('#input-room-id')
    if (nameInput && roomName) nameInput.value = roomName
    if (idInput && roomId) idInput.value = roomId
  }

  private bindEvents(): void {
    byId('btn-enter').addEventListener('click', () => this.handleEnter())

    this.el.querySelector<HTMLInputElement>('#input-room-name')
      ?.addEventListener('keydown', (e) => { if (e.key === 'Enter') this.handleEnter() })

    this.el.querySelector<HTMLInputElement>('#input-room-id')
      ?.addEventListener('keydown', (e) => { if (e.key === 'Enter') this.handleEnter() })

    byId('btn-home-to-about').addEventListener('click', () => this.onNavigate('about'))
  }

  private handleEnter(): void {
    const name = (this.el.querySelector<HTMLInputElement>('#input-room-name')?.value ?? '').trim()
    const id = (this.el.querySelector<HTMLInputElement>('#input-room-id')?.value ?? '').trim()
    if (!name) { alert('请输入直播间名称'); return }
    if (!id) { alert('请输入直播间房间号'); return }
    this.onSubmit(name, id)
  }
}
